module.exports = {
          srcSet: __webpack_public_path__ + "5b481b08.jpg"+" 700w"+","+__webpack_public_path__ + "03adfb0e.jpg"+" 1400w"+","+__webpack_public_path__ + "200c746b.jpg"+" 2100w"+","+__webpack_public_path__ + "353dfa67.jpg"+" 2573w",
          images:[ {path: __webpack_public_path__ + "5b481b08.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "03adfb0e.jpg",width: 1400,height: 934},{path: __webpack_public_path__ + "200c746b.jpg",width: 2100,height: 1401},{path: __webpack_public_path__ + "353dfa67.jpg",width: 2573,height: 1716}],
          src: __webpack_public_path__ + "5b481b08.jpg",
          toString:function(){return __webpack_public_path__ + "5b481b08.jpg"},
          
          width: 700,
          height: 467
        }